var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-tip _hoverble eu-mx_1" },
    [
      _c("div", { staticClass: "emd-tip__container" }, [
        _c(
          "div",
          {
            staticClass:
              "emd-tip__box _color_contrast _arrow_top _position_bottom _no_shadow eu-mt_2 eu-ml_2",
          },
          [_vm._v(" " + _vm._s(_vm.$t("copy")) + " ")]
        ),
      ]),
      _c(
        "emd-button",
        {
          staticClass: "eu-flex eu-align-items_center",
          attrs: { color: "primary", type: "text" },
          on: {
            click: function ($event) {
              return _vm.$emit("click")
            },
          },
        },
        [
          _c("emerald-icon", {
            attrs: { icon: "copy", "data-testid": "button-copy" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }